const envFlag = (value: string | boolean | undefined, fallback: boolean) => {
  if (typeof value === 'boolean') return value
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase()
    if (normalized === 'true') return true
    if (normalized === 'false') return false
  }
  return fallback
}

export const featureFlags = {
  jobs: envFlag(import.meta.env.VITE_ENABLE_JOBS, true),
  emailCampaign: true,
  contentManagement: true,
}
